// Curated palette pairs (primary/secondary) that always look intentional
// together — used to generate consistent, good-looking crest badges for any
// team or league that doesn't have a licensed logo asset wired up yet.
const PALETTE: [string, string][] = [
  ["#DC2626", "#7F1D1D"], // red
  ["#2563EB", "#1E3A8A"], // blue
  ["#059669", "#064E3B"], // green
  ["#7C3AED", "#4C1D95"], // violet
  ["#EA580C", "#7C2D12"], // orange
  ["#0891B2", "#164E63"], // cyan
  ["#DB2777", "#831843"], // pink
  ["#CA8A04", "#713F12"], // gold
  ["#4F46E5", "#312E81"], // indigo
  ["#16A34A", "#14532D"], // emerald
  ["#B91C1C", "#450A0A"], // deep red
  ["#0D9488", "#134E4A"], // teal
];

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

/** Deterministically maps any id/name to a palette pair, so the same team
 * always renders with the same generated badge colors. */
export function colorsFromString(seed: string): { primary: string; secondary: string } {
  const [primary, secondary] = PALETTE[hashString(seed) % PALETTE.length];
  return { primary, secondary };
}
